export const SIGNAL_DETAIL_TYPES = {
  ENTRY: "highs_and_lows__entry",
  TP1: "highs_and_lows__tp1",
  TP2: "highs_and_lows__tp2",
  SL: "highs_and_lows__sl"
};

export const NOTIFICATION_DELIVERY_MODE = {
  BATCH: "batch",
  LIVE: "live"
};

export const SID_SIGNAL_LAYOUT_MODE = {
  BATCH: "batch",
  ENTRY: "entry",
  TP1: "tp1",
  DEFAULT: "default"
};

export function getSidSignalLayoutMode({ detail_type, delivery_mode } = {}) {
  if (delivery_mode === NOTIFICATION_DELIVERY_MODE.BATCH) {
    return SID_SIGNAL_LAYOUT_MODE.BATCH;
  }

  if (detail_type === SIGNAL_DETAIL_TYPES.ENTRY) {
    return SID_SIGNAL_LAYOUT_MODE.ENTRY;
  }

  if (detail_type === SIGNAL_DETAIL_TYPES.TP1) {
    return SID_SIGNAL_LAYOUT_MODE.TP1;
  }

  return SID_SIGNAL_LAYOUT_MODE.DEFAULT;
}
